import { getImageUrl } from '../../utils/imageUrl';
import { useConfirm } from '../../context/ConfirmContext.jsx';
import { ShoppingBag } from 'lucide-react';

const ProductCard = ({ producto, whatsappNumber }) => {
  const { notify } = useConfirm();
  const imageUrl = getImageUrl(producto.imagen);

  // Función para abrir WhatsApp con mensaje predefinido
  const handleOrdenar = () => {
    if (!whatsappNumber) {
      notify.warning('Número de WhatsApp no disponible');
      return;
    }

    // Limpiar el número de WhatsApp
    let cleanNumber = whatsappNumber.replace(/\D/g, '');
    
    // Si empieza con 0 (formato local), convertir a internacional ecuatoriano (593)
    if (cleanNumber.startsWith('0')) {
      cleanNumber = '593' + cleanNumber.substring(1);
    }
    
    if (cleanNumber.length === 9) {
      cleanNumber = '593' + cleanNumber;
    }
    
    // Crear mensaje predefinido
    const mensaje = `Hola! Me interesa ordenar: *${producto.nombre}* - $${Number(producto.precio || 0).toFixed(2)}`;
    const mensajeCodificado = encodeURIComponent(mensaje);
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${mensajeCodificado}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-white rounded-xl sm:rounded-2xl shadow-xs hover:shadow-md border border-gray-100 overflow-hidden flex flex-col justify-between transition-all duration-200 group">
      {/* Imagen del producto */}
      <div className="relative h-28 sm:h-44 md:h-56 bg-gradient-to-br from-red-50 to-orange-50 overflow-hidden">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={producto.nombre}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-300">
            <ShoppingBag className="w-8 h-8 sm:w-12 sm:h-12 opacity-40" />
          </div>
        )}
        
        {/* Badge de categoría */}
        {producto.categoria && (
          <div className="absolute top-2 left-2 sm:top-3 sm:left-3">
            <span className="bg-red-600/95 text-white px-2 py-0.5 sm:px-2.5 sm:py-1 rounded-full text-[10px] sm:text-xs font-semibold shadow-xs backdrop-blur-xs">
              {producto.categoria.nombre}
            </span>
          </div>
        )}
      </div>

      {/* Contenido */}
      <div className="p-2.5 sm:p-4 flex flex-col justify-between flex-1">
        <div>
          <h3 className="text-xs sm:text-base font-bold text-gray-900 line-clamp-1 group-hover:text-red-600 transition-colors">
            {producto.nombre}
          </h3>
          
          <p className="text-gray-500 text-[11px] sm:text-xs mt-0.5 line-clamp-1 sm:line-clamp-2 hidden xs:block">
            {producto.descripcion || 'Preparado fresco con ingredientes seleccionados.'}
          </p>
        </div>

        {/* Precio y botón */}
        <div className="flex items-center justify-between gap-1.5 mt-2 sm:mt-3 pt-2 border-t border-gray-50">
          <div className="text-sm sm:text-lg font-extrabold text-red-600">
            ${Number(producto.precio || 0).toFixed(2)}
          </div>
          
          <button 
            type="button"
            onClick={handleOrdenar}
            className="bg-red-600 hover:bg-red-700 text-white px-2.5 sm:px-4 py-1 sm:py-1.5 rounded-full transition-colors text-[11px] sm:text-xs font-semibold shadow-xs flex items-center gap-1 cursor-pointer shrink-0"
          >
            <span>Pedir</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
